import { EMAIL_GENERIC_CHANNEL_ID, WHATSAPP_GENERIC_CHANNEL_ID } from 'conversations-message-history/common-message-format/constants/genericChannelIds';
import { getGenericChannelId } from 'conversations-message-history/common-message-format/operators/commonMessageGetters';
import { getCommonMessage } from 'conversations-thread-data/common-reply/public/operators/commonReplyGetters';
import { SendActionBanner } from '../../../whatsapp/protected/components';
import { useSelector } from 'react-redux';
import { getAuthAsPojo } from 'conversations-thread-data/auth/public/selectors';
import { jsx as _jsx } from "react/jsx-runtime";
export const SUPER_ADMIN_SCOPE = 'super-admin';
export const CompositionMethod = ({
  reply,
  richTextEditor,
  inboxId,
  onSend
}) => {
  const auth = useSelector(getAuthAsPojo);
  const isAdmin = auth && auth.user.scopes.includes(SUPER_ADMIN_SCOPE);
  const commonMessage = getCommonMessage(reply);
  const genericChannelId = getGenericChannelId(commonMessage);
  switch (genericChannelId) {
    case EMAIL_GENERIC_CHANNEL_ID:
      return richTextEditor;
    case WHATSAPP_GENERIC_CHANNEL_ID:
      return /*#__PURE__*/_jsx(SendActionBanner, {
        reply: reply,
        inboxId: inboxId,
        isAdmin: isAdmin,
        onSend: onSend
      });
    default:
      return richTextEditor;
  }
};
CompositionMethod.displayName = 'CompositionMethod';